import { GroupMember } from '@ih/app/shared/apis/interfaces';

export class FindAllDefaultRoles {
  public static readonly type = '[Group/GroupMember/List] FindAllDefaultRoles';
  constructor(public readonly groupMembers: GroupMember[]) {}
}
